export default "<div class=\"footer-inner\">\r\n  <img src=\"./../../../assets/imgs/poweredby2.png\" alt=\"\" class=\"powered-by\">\r\n</div>"